/**
 * Collection mobile : barre recherche, hauteur carte, bottom sheet logements (snap + drag).
 */
(function () {
  'use strict';

  var SNAP = { COLLAPSED: 0, DEFAULT: 1, EXPANDED: 2 };
  var currentSnap = SNAP.DEFAULT;
  var sheetDragging = false;
  var sheetDragMoved = false;
  var sheetDragState = null;

  function clearMobileGridViewportFilter() {
    if (typeof window.LovenClearMapViewportGridFilter === 'function') {
      window.LovenClearMapViewportGridFilter();
    }
  }

  function invalidateMap() {
    var m = window.__lovenCollectionLeafletMap;
    if (typeof window.LovenInvalidateCollectionMapLayout === 'function') {
      window.LovenInvalidateCollectionMapLayout(m);
      return;
    }
    if (m && typeof m.invalidateSize === 'function') {
      try {
        m.invalidateSize({ animate: false });
      } catch (e) {}
    }
  }

  function scheduleMapFix() {
    clearMobileGridViewportFilter();
    invalidateMap();
    setTimeout(function () {
      clearMobileGridViewportFilter();
      invalidateMap();
    }, 120);
    setTimeout(function () {
      clearMobileGridViewportFilter();
      invalidateMap();
    }, 400);
  }

  function isMapMobile() {
    var root = document.getElementById('CollectionAjaxResult');
    try {
      return (
        root &&
        root.classList.contains('loven-collection-map-mobile') &&
        window.matchMedia('(max-width: 768px)').matches
      );
    } catch (e) {
      return false;
    }
  }

  function getRoot() {
    return document.getElementById('CollectionAjaxResult');
  }

  function readMapTopPx() {
    var root = getRoot();
    if (!root) return 120;
    var v = parseInt(
      getComputedStyle(root).getPropertyValue('--loven-mobile-map-top') || '120',
      10
    );
    return isNaN(v) ? 120 : v;
  }

  function getAvailableHeight() {
    var vh =
      (window.visualViewport && window.visualViewport.height) ||
      window.innerHeight ||
      600;
    return Math.max(160, vh - readMapTopPx());
  }

  function measurePeekHeight() {
    var chrome = document.getElementById('loven-rooms-sheet-chrome');
    if (!chrome) return 96;
    var h = Math.ceil(chrome.getBoundingClientRect().height);
    return h > 48 ? h : 96;
  }

  function getSnapHeights() {
    var avail = getAvailableHeight();
    var peek = measurePeekHeight();
    return {
      collapsed: peek,
      default: Math.round(Math.max(peek + 80, avail * 0.42)),
      expanded: Math.round(Math.max(peek + 120, avail * 0.92))
    };
  }

  function readCurrentSheetHeight() {
    var root = getRoot();
    if (!root) return getSnapHeights().default;
    var raw = getComputedStyle(root).getPropertyValue('--loven-rooms-sheet-height');
    var n = parseInt(String(raw).replace('px', ''), 10);
    if (!isNaN(n) && n > 0) return n;
    return getSnapHeights().default;
  }

  function setSheetHeightPx(h, withTransition) {
    var root = getRoot();
    var sheet = document.getElementById('loven-rooms-sheet-root');
    if (!root || !sheet) return;
    var avail = getAvailableHeight();
    var peek = measurePeekHeight();
    var maxH = Math.round(avail * 0.95);
    h = Math.max(peek, Math.min(maxH, Math.round(h)));
    var overlap = 20;
    var mapH = Math.max(120, avail - h + overlap);

    root.style.setProperty('--loven-rooms-sheet-height', h + 'px');
    root.style.setProperty('--loven-mobile-map-height', mapH + 'px');
    sheet.style.height = h + 'px';

    if (withTransition === false) {
      root.classList.add('loven-rooms-sheet--no-transition');
      requestAnimationFrame(function () {
        root.classList.remove('loven-rooms-sheet--no-transition');
      });
    }
    scheduleMapFix();
  }

  var sheetSnapBeforePreview = null;

  window.LovenRoomsSheetCollapseForMapPreview = function () {
    if (!isMapMobile()) return;
    sheetSnapBeforePreview = currentSnap;
    applySnapState(SNAP.COLLAPSED, true);
    var root = getRoot();
    if (root) root.classList.add('loven-map-pin-preview-open');
  };

  window.LovenRoomsSheetRestoreAfterMapPreview = function () {
    if (!isMapMobile()) return;
    var root = getRoot();
    if (root) root.classList.remove('loven-map-pin-preview-open');
    applySnapState(
      sheetSnapBeforePreview != null ? sheetSnapBeforePreview : SNAP.DEFAULT,
      true
    );
    sheetSnapBeforePreview = null;
  };

  function applySnapState(snap, withTransition) {
    if (!isMapMobile()) return;
    var root = getRoot();
    if (!root) return;
    var heights = getSnapHeights();
    var h =
      snap === SNAP.COLLAPSED
        ? heights.collapsed
        : snap === SNAP.EXPANDED
          ? heights.expanded
          : heights.default;
    currentSnap = snap;

    root.classList.remove(
      'loven-rooms-sheet--collapsed',
      'loven-rooms-sheet--default',
      'loven-rooms-sheet--expanded'
    );
    if (snap === SNAP.COLLAPSED) root.classList.add('loven-rooms-sheet--collapsed');
    else if (snap === SNAP.EXPANDED) root.classList.add('loven-rooms-sheet--expanded');
    else root.classList.add('loven-rooms-sheet--default');

    var btn = document.getElementById('loven-rooms-sheet-scroll-cta');
    if (btn) {
      btn.setAttribute('aria-expanded', snap === SNAP.EXPANDED ? 'true' : 'false');
    }

    clearMobileGridViewportFilter();
    setSheetHeightPx(h, withTransition);
  }

  function snapFromHeight(h) {
    var s = getSnapHeights();
    var d1 = Math.abs(h - s.collapsed);
    var d2 = Math.abs(h - s.default);
    var d3 = Math.abs(h - s.expanded);
    if (d1 <= d2 && d1 <= d3) return SNAP.COLLAPSED;
    if (d3 < d2) return SNAP.EXPANDED;
    return SNAP.DEFAULT;
  }

  function teardownRoomsSheet() {
    var root = getRoot();
    var chrome = document.getElementById('loven-rooms-sheet-chrome');
    if (chrome) chrome.removeAttribute('data-loven-sheet-init');
    if (!root) return;
    root.classList.remove(
      'loven-rooms-sheet--interactive',
      'loven-rooms-sheet--collapsed',
      'loven-rooms-sheet--default',
      'loven-rooms-sheet--expanded',
      'loven-rooms-sheet--dragging',
      'loven-rooms-sheet--no-transition'
    );
    root.style.removeProperty('--loven-rooms-sheet-height');
    var sheet = document.getElementById('loven-rooms-sheet-root');
    if (sheet) sheet.style.removeProperty('height');
    setMobileMapHeight();
  }

  function canStartSheetDrag(e) {
    var chrome = document.getElementById('loven-rooms-sheet-chrome');
    var body = document.getElementById('loven-rooms-sheet-body');
    if (chrome && chrome.contains(e.target)) return true;
    if (!body || !body.contains(e.target)) return false;
    if (body.scrollTop > 2) return false;
    if (e.target.closest('a, button, input, textarea, select, [role="button"], .grid-product__link')) {
      return false;
    }
    return true;
  }

  function bindSheetDragListeners() {
    document.addEventListener('pointermove', onSheetPointerMove);
    document.addEventListener('pointerup', onSheetPointerUp);
    document.addEventListener('pointercancel', onSheetPointerUp);
  }

  function unbindSheetDragListeners() {
    document.removeEventListener('pointermove', onSheetPointerMove);
    document.removeEventListener('pointerup', onSheetPointerUp);
    document.removeEventListener('pointercancel', onSheetPointerUp);
  }

  function onSheetPointerDown(e) {
    if (!isMapMobile()) return;
    if (!canStartSheetDrag(e)) return;
    if (e.button != null && e.button !== 0) return;

    sheetDragMoved = false;
    sheetDragging = true;
    sheetDragState = {
      startY: e.clientY,
      startH: readCurrentSheetHeight(),
      pointerId: e.pointerId,
      fromChrome: !!(e.target.closest && e.target.closest('#loven-rooms-sheet-chrome'))
    };

    var root = getRoot();
    if (root) root.classList.add('loven-rooms-sheet--dragging');

    bindSheetDragListeners();
    e.preventDefault();
  }

  function onSheetPointerMove(e) {
    if (!sheetDragging || !sheetDragState || e.pointerId !== sheetDragState.pointerId) return;
    var dy = sheetDragState.startY - e.clientY;
    if (Math.abs(dy) > 6) sheetDragMoved = true;
    setSheetHeightPx(sheetDragState.startH + dy, false);
    e.preventDefault();
  }

  function onSheetPointerUp(e) {
    if (!sheetDragging || !sheetDragState || e.pointerId !== sheetDragState.pointerId) return;

    unbindSheetDragListeners();

    var root = getRoot();
    if (root) root.classList.remove('loven-rooms-sheet--dragging');

    if (sheetDragMoved) {
      applySnapState(snapFromHeight(readCurrentSheetHeight()), true);
    } else if (sheetDragState.fromChrome) {
      onSheetTap();
    }

    sheetDragging = false;
    sheetDragState = null;
  }

  function onSheetTap() {
    if (currentSnap === SNAP.COLLAPSED) applySnapState(SNAP.DEFAULT, true);
    else if (currentSnap === SNAP.DEFAULT) applySnapState(SNAP.EXPANDED, true);
    else applySnapState(SNAP.DEFAULT, true);
  }

  function initRoomsSheet() {
    if (!isMapMobile()) {
      teardownRoomsSheet();
      return;
    }
    var root = getRoot();
    var chrome = document.getElementById('loven-rooms-sheet-chrome');
    var sheet = document.getElementById('loven-rooms-sheet-root');
    if (!root || !chrome || !sheet) return;
    if (chrome.getAttribute('data-loven-sheet-init') === '1') {
      applySnapState(currentSnap, false);
      return;
    }
    chrome.setAttribute('data-loven-sheet-init', '1');
    root.classList.add('loven-rooms-sheet--interactive');

    chrome.addEventListener('pointerdown', onSheetPointerDown);
    var body = document.getElementById('loven-rooms-sheet-body');
    if (body) body.addEventListener('pointerdown', onSheetPointerDown);

    applySnapState(currentSnap, false);
  }

  function setMobileMapHeight() {
    var root = getRoot();
    if (!root || !root.classList.contains('loven-collection-map-mobile')) return;
    if (!window.matchMedia('(max-width: 768px)').matches) {
      root.style.removeProperty('--loven-mobile-map-height');
      return;
    }
    if (root.classList.contains('loven-rooms-sheet--interactive')) {
      applySnapState(currentSnap, false);
      return;
    }
    var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight || 600;
    var h = Math.round(Math.min(Math.max(vh * 0.38, 216), Math.min(460, vh * 0.46)));
    root.style.setProperty('--loven-mobile-map-height', h + 'px');
  }

  function measureSearchStack() {
    var root = getRoot();
    if (!root || !root.classList.contains('loven-collection-map-mobile')) return;
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    var avail = document.getElementById('avail-search');
    if (avail && avail.classList.contains('loven-mobile-search-open')) return;
    var bar = root.querySelector('.collection-search-bar');
    if (!bar) return;
    var h = Math.ceil(bar.getBoundingClientRect().height);
    root.style.setProperty('--loven-collection-search-stack', h + 'px');
    root.style.setProperty('--loven-mobile-map-top', h + 'px');
    setMobileMapHeight();
    scheduleMapFix();
    initRoomsSheet();
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function init() {
    setMobileMapHeight();
    measureSearchStack();
    window.LovenMeasureCollectionSearchStack = measureSearchStack;
    requestAnimationFrame(function () {
      requestAnimationFrame(measureSearchStack);
    });
    scheduleMapFix();
    window.addEventListener(
      'resize',
      debounce(function () {
        if (!window.matchMedia('(max-width: 768px)').matches) {
          teardownRoomsSheet();
        }
        measureSearchStack();
        if (window.matchMedia('(max-width: 768px)').matches) scheduleMapFix();
      }, 150)
    );
    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        'resize',
        debounce(function () {
          setMobileMapHeight();
          measureSearchStack();
          scheduleMapFix();
        }, 120)
      );
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('collection:reloaded', function () {
    setMobileMapHeight();
    measureSearchStack();
    scheduleMapFix();
  });
})();
